import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import logo from '../../assets/logo.svg';
import styles from './loadingScreen.module.css';

const shineMask = {
    WebkitMaskImage: `url(${logo})`,
    maskImage: `url(${logo})`,
};

function LoadingScreen({ open = false, message = 'Loading…' }) {
    useEffect(() => {
        if (!open) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [open]);

    if (!open) return null;

    return createPortal(
        <div className={styles.overlay} role="status" aria-live="polite" aria-busy="true">
            <div className={styles.logo}>
                <img src={logo} alt="" className={styles.image} />
                <span className={styles.shine} style={shineMask} aria-hidden="true" />
            </div>
            <p className={styles.message}>{message}</p>
        </div>,
        document.body
    );
}

export default LoadingScreen;
